module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.consulta) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabConfig),
      callback: function($$v) {
        _vm.tabConfig = $$v
      },
      expression: "tabConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-consulta"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-stethoscope"
  }), _vm._v("\n\t\t\t\tInformações da Consulta\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "row p-1"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0 border-right-0"
  }, [_c('b', [_vm._v("Cód")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.id) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0"
  }, [_c('b', [_vm._v("Funcionário")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.funcionario.nome) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0"
  }, [_c('b', [_vm._v("CPF")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.funcionario.cpf) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border border-bottom-0  border-right-0"
  }, [_c('b', [_vm._v("Função")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border border-bottom-0"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.funcao.nome) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 border  border-right-0"
  }, [_c('b', [_vm._v("Tipo da Consulta")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 border"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.consulta.tipo_aso.descricao) + "\n\t\t\t\t")])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-consulta-exame"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _vm._v("\n\t\t\t\tInformações dos Exames\n\t\t\t")]), _vm._v(" "), _c('table', {
    staticClass: "table historico-consulta"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    }
  }, [_vm._v("Exame")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Valor")])]), _vm._v(" "), _vm._l((_vm.consulta.exames), function(exame) {
    return _c('tr', {
      key: exame.id
    }, [_c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(exame.exame.nome) + "\n\t\t\t\t\t\t"), (exame.id_con_rea) ? _c('span', {
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('br'), _vm._v("\n\t\t\t\t\t\t\tExame reaproveitado na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(exame.id_con_rea))]), _vm._v(" em " + _vm._s(_vm.toDate(exame.data, true)) + "\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (exame.id_con_dem) ? _c('span', {
      staticStyle: {
        "font-size": "9pt"
      }
    }, [_c('br'), _vm._v("\n\t\t\t\t\t\t\tExame demonstrativo na consulta "), _c('label', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(exame.id_con_dem))])]) : _vm._e(), _vm._v(" "), (!exame.pcmso_exame) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_c('br'), _vm._v("Exame não encontrado no PCMSO")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((exame.id_con_rea ? '---' : _vm.toDate(exame.data, true))) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((exame.id_con_rea ? '---' : exame.valor)) + "\n\t\t\t\t\t")])])
  })], 2)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-consulta-risco"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n\t\t\t\tInformações dos Riscos\n\t\t\t")]), _vm._v(" "), _c('table', {
    staticClass: "table historico-consulta"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "font-size": "7pt",
      "background": "#eeeeee"
    },
    attrs: {
      "width": "100"
    }
  }, [_vm._v("Risco")])]), _vm._v(" "), _vm._l((_vm.consulta.riscos), function(risco) {
    return _c('tr', {
      key: risco.id
    }, [_c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [(risco.risco) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.risco.categoria.categoria) + "\n\t\t\t\t\t\t")]) : (risco.categoria) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.categoria.categoria) + "\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "8pt"
      }
    }, [(risco.risco) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.risco.nome) + "\n\t\t\t\t\t\t")]) : (risco.nome) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(risco.nome) + "\n\t\t\t\t\t\t")]) : _vm._e()])])
  })], 2)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a114b3b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/consulta-externa/_include/consulta-detalhe.vue
// module id = 1576
// module chunks = 45